import React, { FC } from 'react';
import { ThemeColorsKeys } from '../../styles/tokens/colors';
import { Section } from '../section/Section';
import { Spacer } from '../spacer/Spacer';
import { Typography } from '../typography/Typography';
import HtmlContent from '../htmlContent/HtmlContent';
// Interface

export interface SimpleHeroProps {
  heading: string;
  description?: string;
  centered?: boolean;
  backgroundColor?: ThemeColorsKeys;
}

export interface LinkProps {
  url?: string;
  label?: string;
}

// JSX

export const SimpleHero: FC<SimpleHeroProps> = ({
  heading,
  description,
  centered,
  backgroundColor,
}) => (
  <Section centered={centered} backgroundColor={backgroundColor}>
    <Spacer spacing="small">
      {heading && (
        <Typography component="h1" variant="headingLarge">
          <HtmlContent>{heading}</HtmlContent>
        </Typography>
      )}
      {description && <HtmlContent>{description}</HtmlContent>}
    </Spacer>
  </Section>
);

export default SimpleHero;
